<template>
    <div class="product-rating-feedback">
        <Form @submitValid="submit" :errors="errors">
            <p v-if="rating === 0">{{ $t('ProductRatingFeedback.title.negative') }}</p>
            <p v-else>{{ $t('ProductRatingFeedback.title.positive') }}</p>
            <div>
                <textarea
                    v-model="message"
                    :minlength="minlength"
                    :placeholder="messagePlaceHolder"
                    rows="7"
                    :name="$t('ProductRatingFeedback.message.placeholder')"
                    class="form-control input-gray mb-2"
                    :required="rating === 0"
                >
                </textarea>
                <small class="form-text text-muted">{{ helpText }}</small>
            </div>
            <div v-if="rating === 0">
                <input type="text"
                    v-model="email"
                    :placeholder="$t('ProductRatingFeedback.email.placeholder')"
                    :name="$t('ProductRatingFeedback.email.placeholder')"
                    class="form-control input-gray mb-2 mt-2" />
            </div>
            <div v-if="rating === 0">
                <input type="text"
                    v-model="phone"
                    :placeholder="$t('ProductRatingFeedback.phone.placeholder')"
                    :name="$t('ProductRatingFeedback.phone.placeholder')"
                    class="form-control input-gray mb-2" />
            </div>
            <div v-if="rating === 0">
                <input type="text"
                    v-model="voucherNumber"
                    :placeholder="$t('ProductRatingFeedback.voucherNumber.placeholder')"
                    :name="$t('ProductRatingFeedback.voucherNumber.placeholder')"
                    class="form-control input-gray mb-2" />
            </div>

            <div class="product-rating-feedback__actions mt-3">
                <button
                    type="reset"
                    @click="cancelFeedback"
                    class="product-rating-feedback__reset btn btn-light text-uppercase"
                >
                    {{ $t('Generic.abort') }}
                </button>
                <button type="submit" class="btn btn-primary text-uppercase">{{ $t('Form.button.send') }}</button>
            </div>
        </Form>
    </div>
</template>

<script>
import Form from '@/components/Form';

export default {
    name: 'ProductRatingFeedback',
    components: { Form },
    data() {
        return {
            message: '',
            email: '',
            phone: '',
            voucherNumber: ''
        };
    },
    props: {
        errors: {
            type: Array
        },
        rating: {
            type: Number,
            required: true
        },
        minlength: {
            type: Number,
            required: true
        }
    },
    computed: {
        helpText() {
            return this.$t('ProductRatingFeedback.message.helpText', { minlength: this.minlength });
        },
        messagePlaceHolder() {
            return this.rating === 0
                ? this.$t('ProductRatingFeedback.message.placeholder')
                : this.$t('ProductRatingFeedback.message.placeholder_optional');
        },

    },
    methods: {
        submit() {
            this.$emit('submit', {
                message: this.message,
                email: this.email,
                phone: this.phone,
                voucherNumber: this.voucherNumber
            });
        },
        cancelFeedback() {
            this.$emit('cancel');
        }
    }
};
</script>

<style lang="scss" scoped>
.product-rating-feedback {
    &__actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
    }

    &__reset {
        border: 1px solid var(--border-color);
    }
}
</style>
